var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.mini
        ? _c("div", [
            _vm.code && !_vm.loading
              ? _c("span", { staticClass: "code mini mr-5" }, [
                  _vm._v(_vm._s(_vm.code))
                ])
              : _vm._e(),
            !_vm.code && !_vm.loading
              ? _c("span", { staticClass: "code mini  mr-5" }, [
                  _vm._v("------")
                ])
              : _vm._e(),
            _vm.loading
              ? _c("span", { staticClass: "code mini mr-5" }, [
                  _vm._v(_vm._s(_vm.randomNumber))
                ])
              : _vm._e()
          ])
        : _vm._e(),
      !_vm.mini
        ? _c(
            "v-card",
            [
              _c("v-card-title", [_vm._v(" " + _vm._s(_vm.title) + " ")]),
              _c(
                "v-card-text",
                [
                  _vm._t("default"),
                  _vm.code && !_vm.loading
                    ? _c("span", { staticClass: "code" }, [
                        _vm._v(_vm._s(_vm.code)),
                        _c("div", { staticClass: "countdown" }, [
                          _vm._v(_vm._s(_vm.countdownText))
                        ])
                      ])
                    : _vm._e(),
                  !_vm.code && !_vm.loading
                    ? _c("span", { staticClass: "code" }, [
                        _vm._v("------"),
                        _c("div", { staticClass: "countdown" })
                      ])
                    : _vm._e(),
                  _vm.loading
                    ? _c("span", { staticClass: "code" }, [
                        _vm._v(_vm._s(_vm.randomNumber)),
                        _c("div", { staticClass: "countdown" }, [
                          _vm._v("Generating unique code")
                        ])
                      ])
                    : _vm._e()
                ],
                2
              ),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  !_vm.noButton
                    ? _c(
                        "v-btn",
                        {
                          attrs: { color: "green" },
                          on: { click: _vm.generateShortcode }
                        },
                        [
                          _c("v-icon", { staticClass: "mr-2" }, [
                            _vm._v(" mdi-dialpad ")
                          ]),
                          _vm._v("Generate code ")
                        ],
                        1
                      )
                    : _vm._e(),
                  _c("v-spacer")
                ],
                1
              )
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }